<template>
  <div id="app">
     <loading 
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"/>
    <div
      class="modal fade alertModal"
      id="caveat"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <i class="fas fa-exclamation text-warning exclamation"></i>
            <p class="title mt-2 pb-3 text-green">訊息</p>
            <div class="content d-flex justify-content-center w-100 mt-4">
              <div class="text-white" v-html="modalContent"></div>
            </div>
            <div class="btn-group mt-4">
              <button class="btn btn-green" @click="closeModal('caveat')">確定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
import $ from "jquery";    
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: {
      Loading
  },
  data() {
    return {
      modalContent: "",
      fullPage: true
    };
  },
  computed: {
    isLoading(){
      return this.$store.state.isLoading
    }
  },
  methods: {
    closeModal() {}
  },
  created(){
    if(this.$route.path.indexOf('//') != -1) {
      this.$router.push({
        name:this.$route.path.split('//')[1],
        query: this.$route.query
      })
    }
  }
};
</script>
<style lang="scss">
@import "./assets/all.scss";
body {
  background-color: #28323c;
}
.copyBtn {
  position: absolute;
  z-index: 999;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.btn-green {
  color: #fff;
  background: #2e9e83 -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#54c5a9),
      to(#2e9e83)
    ) repeat-x;
  background: #2e9e83 linear-gradient(180deg, #54c5a9, #2e9e83) repeat-x;
  border-color: #2e9e83;
  font-size: 14px;
}
.wallet_name {
  .account_name {
    color: white;
  }
}
.payMethod {
  margin-bottom: 15px;
  .pay {
    box-sizing: border-box;
    margin-top: 15px;
    margin-right: 15px;
    width: 200px;
    border-radius: 5px;
    min-height: 70px;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    cursor: pointer;
    .payContent {
      p.title {
        font-size: 18px;
        font-weight: bold;
        width: 100%;
        line-height: 18px;
        margin-top: 6px;
      }
      p {
        font-size: 16px;
        margin: 15px 24px;
      }
    }
    .left {
      width: 15px;
      height: 100%;
      background-color: #3b9aa0;
      border-bottom-left-radius: 5px;
      border-top-left-radius: 5px;
      position: absolute;
      left: 0;
      top: -1px;
    }
    &:hover,
    &.active {
      .left {
        height: calc(100% + 2px);
        background-color: #2e9e83;
      }
      //   height: 68px;
      border: 1px solid white;
      border-left: none !important;
      p.title {
        margin-top: 5px;
      }
    }
  }
}
@media (max-width: 550px) {
  .payMethod {
    .pay {
      width: 295px;
    }
    .payContent {
      margin-left: 15px;
    }
  }
}
p {
  color: white;
}
.tit1 {
  color: #2e9e83;
  font-size: 30px;
  font-weight: bold;
  min-width: 97px;
  margin-right: 5%;
  margin-bottom: 15px;
  margin-top: 15px;
  text-align: left;
  width: 100%;
  margin-bottom: 50px;
}
.allWrap {
  padding: 25px;
  width: 95%;
  margin-left: 2.5%;
  min-height: 90vh;
  border-radius: 10px;
  border: 1px solid #64c8c3;
  display: flex;
  justify-content: center;
}
.wrap {
  width: 80%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .wrap {
    width: 100%;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.account_name {
  margin-left: 0 !important;
}
.inputWrap {
  max-width: 1200px;
  width: 100%;
}
@media (max-width: 321px) {
  .inputWrap {
    max-width: 310px;
  }
}
</style>
